import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAnimateOnView } from '../../hooks/useIntersectionObserver';
import { pricing } from '../../data/pricing';
import ServicesSection from './ServicesSection';
import './PricesSection.css';

const CheckIcon: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 12.5 9 17.5 20 6" />
  </svg>
);

const PricesSection: React.FC = () => {
  const navigate = useNavigate();
  const [ref, shouldAnimate] = useAnimateOnView();

  return (
    <section
      ref={ref}
      className={`prices-section section-padding${shouldAnimate ? ' loaded' : ''}`}
      id="prices"
    >
      <div className="container">
        <div className="section-header pr-header">
          <span className="pr-eyebrow">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 2v20M17 6.5c0-1.9-2.2-3-5-3s-5 1.3-5 3 2.2 3 5 3 5 1.1 5 3-2.2 3-5 3-5-1.1-5-3" />
            </svg>
            Nuestros Precios
          </span>
          <h2 className="section-title pr-title">
            <span>Inversión en tu relación y bienestar</span>
          </h2>
        </div>

        <div className="pr-grid">
          {pricing.map((price, index) => (
            <div
              key={price.id}
              className={`pr-card${price.featured ? ' pr-card--featured' : ''} animate-in`}
              style={{ '--delay': `${0.2 + index * 0.1}s` } as React.CSSProperties}
            >
              {price.featured && (
                <span className="pr-card__badge">Recomendado</span>
              )}

              <h3 className="pr-card__name">{price.name}</h3>
              <div className="pr-card__amount">{price.amount}</div>
              <div className="pr-card__cycle">{price.cycle}</div>

              <ul className="pr-card__features">
                {price.features.map((feature, i) => (
                  <li key={i}>
                    <CheckIcon />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href="/agendar"
                className={`pr-btn${price.featured ? ' pr-btn--primary' : ' pr-btn--outline'}`}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/agendar');
                }}
              >
                {price.featured ? 'Elegir Este Plan' : 'Agendar Ahora'}
              </a>
            </div>
          ))}
        </div>

        {/* Otros servicios (online, sexología, domicilio) — sin duplicar las cards */}
        <ServicesSection />

        <div className="pr-note animate-in" style={{ '--delay': '0.6s' } as React.CSSProperties}>
          <i className="fas fa-info-circle" aria-hidden="true"></i>
          Al pagar con transferencia o efectivo accedes a un valor preferente en sesiones presenciales.
          Todos los planes incluyen boletas reembolsables con Isapre y seguros complementarios.
        </div>

        <div className="pr-note pr-note--payment animate-in" style={{ '--delay': '0.7s' } as React.CSSProperties}>
          <i className="fas fa-credit-card" aria-hidden="true"></i>
          Paga como te acomode: transferencia o efectivo (valor preferente), o débito y crédito en la clínica.
        </div>
      </div>
    </section>
  );
};

export default PricesSection;
